export enum Role {
  OEM = 'lenovo.boost.prc.oem.access',
  MSP = 'lenovo.boost.prc.msp.access',
}
